import { render, staticRenderFns } from "./jfqk.vue?vue&type=template&id=0dfd53b6&scoped=true&"
import script from "./jfqk.vue?vue&type=script&lang=js&"
export * from "./jfqk.vue?vue&type=script&lang=js&"
import style0 from "./jfqk.vue?vue&type=style&index=0&id=0dfd53b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd53b6",
  null
  
)

export default component.exports